import { render, staticRenderFns } from "./help1.vue?vue&type=template&id=7e604846&scoped=true"
import script from "./help1.vue?vue&type=script&lang=js"
export * from "./help1.vue?vue&type=script&lang=js"
import style0 from "./help1.vue?vue&type=style&index=0&id=7e604846&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e604846",
  null
  
)

export default component.exports